import axios from "axios";

const getPresignedUrl = ({ fileName, type, clientId }) => {
    return axios.post(process.env.VUE_APP_GENERATE_PRESIGNED_URL, {
        fileName,
        type,
        clientId
    });
};

export default {
    getPresignedUrl
};
